// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r147","right":"styles_right__CfIhl"};